import { jsonApi } from '@models/jsonApi';

jsonApi.define('ams/redirect-rule', {
  domain: '',
  is_active: true,
  created_at: null,
  updated_at: null,
  deleted_at: null,
});
